import { ErrorPageLayout } from "@layouts";

const NotFound = () => (
    <ErrorPageLayout
        title="Missing Page"
        description={
            <>
                <p className="text-sm leading-5 tracking-[0.14px] text-neutral-700">
                    But it’s around here somewhere! Please check the link you’re using or refresh the page.
                </p>
                <p className="text-xs leading-4 tracking-[0.12px] text-neutral-700 mt-2">
                    Or if you have any questions, feel free to reach out <a href="mailto:help@sunbound.ai" className="text-blue-800 focus-visible:outline-focus-ring rounded">here</a>.
                </p>
            </>
        }
        error="Error 404"
        showLogo={true}
    />
);

export default NotFound;
